import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sanitizePdf'
})
export class SanitizePdfPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }

    return value
      // Replace smart/curly double quotes with straight quotes
      .replace(/[\u201C\u201D]/g, '"')  // " " → "
      // Replace smart/curly single quotes with straight quotes
      .replace(/[\u2018\u2019]/g, "'")  // ' ' → '
      // Replace ellipsis
      .replace(/\u2026/g, '...')        // … → ...
      // Replace em dash
      .replace(/\u2014/g, '--')         // — → --
      // Replace en dash
      .replace(/\u2013/g, '-')          // – → -
      // Additional common problematic characters
      .replace(/\u00AB/g, '<<')         // « → <<
      .replace(/\u00BB/g, '>>')         // » → >>
      .replace(/\u2022/g, '*')          // • → *
      .replace(/\u00B5/g, 'u')          // µ → u (micro symbol)
      .replace(/\u00A0/g, ' ');         // non-breaking space → space
  }
}
